var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ModalContainer'),(_vm.location === 'enskede')?_c('Header'):_vm._e(),(_vm.location === 'haga-norra')?_c('HeaderHagaNorra'):_vm._e(),(_vm.location === 'slaktis')?_c('HeaderSlaktis'):_vm._e(),_c('router-view'),(_vm.hasLocation)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }